import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { Lock, X, Loader } from 'lucide-react';
import { VERIFICAR_PASSWORD_CONFIGURACION } from '../../graphql/configuracion';
import './PasswordModal.css';

const PasswordModal = ({ onSuccess }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isShaking, setIsShaking] = useState(false);
  const navigate = useNavigate();

  const [verificarPassword, { loading }] = useMutation(VERIFICAR_PASSWORD_CONFIGURACION);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await verificarPassword({ variables: { password } });
      if (data.verificarPasswordConfiguracion) {
        onSuccess();
      }
    } catch (err) {
      setError(err.message || 'Contraseña incorrecta');
      setPassword('');
      setIsShaking(true);
      setTimeout(() => setIsShaking(false), 500);
    }
  };

  const handleCancel = () => {
    navigate('/dashboard');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      handleCancel();
    }
  };

  return (
    <div className="password-modal-overlay" onKeyDown={handleKeyDown}>
      <div className={`password-modal ${isShaking ? 'password-modal--shake' : ''}`}>
        <button
          className="password-modal__close"
          onClick={handleCancel}
          type="button"
          aria-label="Cerrar"
        >
          <X size={20} />
        </button>

        <div className="password-modal__header">
          <div className="password-modal__icon">
            <Lock size={32} />
          </div>
          <h2 className="password-modal__title">Acceso Restringido</h2>
          <p className="password-modal__subtitle">
            Ingrese su contraseña de usuario para acceder a la configuración del sistema
          </p>
        </div>

        <form onSubmit={handleSubmit} className="password-modal__form">
          <div className="password-modal__input-group">
            <input
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError('');
              }}
              placeholder="Contraseña"
              className={`password-modal__input ${error ? 'password-modal__input--error' : ''}`}
              autoFocus
              autoComplete="off"
              disabled={loading}
            />
            {error && (
              <span className="password-modal__error">{error}</span>
            )}
          </div>

          <div className="password-modal__actions">
            <button
              type="button"
              className="password-modal__btn password-modal__btn--cancel"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="password-modal__btn password-modal__btn--submit"
              disabled={!password || loading}
            >
              {loading ? <Loader size={16} className="spinner" /> : 'Ingresar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PasswordModal;
